import styled from 'styled-components'

import { SwitchUnstyled } from './unstyled'

const Switch = styled(SwitchUnstyled)``
export default Switch
